import httpClient, {
  FormMultiPart,
  FormUrlEncoded,
  ApplicationJson,
  POST,
  PUT,
  GET,
  DELETE,
} from "@/apis/base/axios-httpclient";
import BaseAPI from "./base/base-api";

class OptionAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Option";

  /**
   * ovrrides lại hàm này để xử lý.
   */
  update(payload) {
    let request = {
      url: [this.getAPIUrl(), "update-dboption"].join("/"),
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }
}

export default new OptionAPI();
